import { contentStylesDefaults } from '@/features/content-styles-form/lib/defaults';

import { SliderContentOut, VideoContentOut } from './schema';

const publication = {
  name: '',
  sites: [],
  zones: [],
  categories: [],
  publication: 0,
  publication_urls: '',
};

export const sliderContentDefaults: SliderContentOut = {
  // export const sliderContentDefault: DefaultValues<SliderContent> = {
  type: 'slider',
  status: 0,
  config: contentStylesDefaults,

  ...publication,

  // slider:
  rss_settings: {
    link: '',
    limit: 5,
    auto_update: {
      enabled: Boolean(false),
      time: '00:00',
      interval_days: 1,
    },
  },
  slides: [
    {
      image: '',
      title: '',
      link: '',
    },
  ],
};

export const videoContentDefaults: VideoContentOut = {
  type: 'video',
  status: 0,
  config: contentStylesDefaults,

  ...publication,

  // video:
  editor_config: '',
  text_blocks: [],
};
